<template>
  <div class="modal-body-user-info">
    <div class="description">
      Add a new validator by entering the information below.
    </div>
    <div class="email">
      <div class="text">Name:</div>
      <div>
        <input class="input" type="text" placeholder="Name" v-model="validatorInfo.name">
      </div>
    </div>
    <div class="name row">
      <div class="first-name">
        <div class="text">Field:</div>
        <div>
          <input class="input" type="text" placeholder="enum.validator.field.last_name" v-model="validatorInfo.field" :disabled="true">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {mapGetters} from 'vuex';
// import consts from '../../_consts';

export default {
  name: 'add-client-body-modal',
  data () {
    return {};
  },
  props: {
    validatorInfo: {
      type: Object,
      default: {}
    }
  },
  methods: {
  },
  watch: {
    clientInfo: {
      handler: function () {
        if (this.clientInfo.email) {
          this.isEmail(this.clientInfo.email);
        }
      },
      deep: true
    }
  },
  created () {
    this.$emit('disableBtnRight', true);
  }
}
</script>

<style lang="less">
  .modal-body-user-info{
    color: #231F20;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    margin-bottom: 60px;
    .description{
      line-height: 14px;
    }
    .input{
      height: 38px;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      padding-left: 12px;
    }
    .name{
      margin: 30px 0 0 0;
      .last-name{
        margin-left: 40px;
        .text{}
        .input{
          width: 275px;
        }
      }
      .first-name{
        .text{}
        .input{
          width: 275px;
        }
      }
    }
    .email{
      margin: 30px 0 0 0;
      .text{}
      .input{
        width: 590px;
      }
    }
    .errorBackground {
      background-color: #FEE2E2;
      width: 588px;
      margin-top: 1px;
    }
    .errorDetail {
      height: 17px;
      width: 108px;
      color: #803939;
      font-family: "Open Sans",serif;
      font-size: 12px;
      line-height: 17px;
      text-align: right;
      margin-left: 5px;
    }
  }
</style>




// WEBPACK FOOTER //
// AddValidator.vue?85b63fce